import {isFeatureEnabled} from '@github-ui/feature-flags'

export function isAgentsEnabled() {
  return isFeatureEnabled('repo_app_agents')
}

export function isIssuesEnabled() {
  return isFeatureEnabled('repo_app_issues')
}

export function isPullRequestsEnabled() {
  return isFeatureEnabled('repo_app_pull_requests')
}

export function isCodeViewEnabled() {
  return isFeatureEnabled('repo_app_code_view')
}

export function canSoftNavToCodeView() {
  return isFeatureEnabled('repo_app_code_view') && !isFeatureEnabled('ui_route_code_view')
}
